export default "__VITE_ASSET__BcEBWUlk__"